import { ref, computed } from 'vue'

export interface GlobalFormMessage {
  message: string
  type?: 'error' | 'warning' | 'info' | 'success'
}

export function useGlobalFormMessages() {
  const errors = ref<GlobalFormMessage[]>([])
  const showErrors = ref(false)

  // Add a single error
  const addError = (error: GlobalFormMessage) => {
    errors.value.push(error)
  }

  // Add multiple errors
  const addErrors = (newErrors: GlobalFormMessage[]) => {
    errors.value.push(...newErrors)
  }

  // Clear all errors
  const clearErrors = () => {
    errors.value = []
  }

  // Remove a specific error by message
  const removeError = (message: string) => {
    errors.value = errors.value.filter(error => error.message !== message)
  }

  // Get the main form error (usually the first one)
  const mainError = computed(() => {
    return errors.value.length > 0 ? errors.value[0] : null
  })

  // Check if there are any errors
  const hasErrors = computed(() => {
    return errors.value.length > 0
  })

  // Show validation errors
  const showValidationErrors = () => {
    showErrors.value = true
  }

  // Hide validation errors
  const hideValidationErrors = () => {
    showErrors.value = false
  }

  return {
    // Only expose what's commonly needed
    showErrors,
    addError,
    clearErrors,
    removeError,
    mainError,
    showValidationErrors,
    hideValidationErrors,
    
    // Optional: expose these only if needed elsewhere
    errors,
    hasErrors,
    addErrors,
  }
}